export const labels = {
	previewTooltip: {
		label: "Label.MobileCreator.Tooltip.Preview",
		default: "Preview",
	},
	zoomInTooltip: {
		label: "Label.MobileCreator.Tooltip.ZoomIn",
		default: "Zoom in",
	},
	zoomOutTooltip: {
		label: "Label.MobileCreator.Tooltip.ZoomOut",
		default: "Zoom out",
	},
	spreadOverviewTooltip: {
		label: "Label.MobileCreator.Tooltip.SpreadOverview",
		default: "Spread overview",
	},
} as const;
